import { useEffect } from "react";

export default function useSidebarToggle() {
  useEffect(() => {
    const body = document.body;
    const toggleBtn = document.getElementById("toggle_btn");   // desktop collapse
    const mobileBtn = document.getElementById("mobile_btn");   // mobile slide

    // ensure overlay exists when needed
    const ensureOverlay = () => {
      let ov = document.querySelector(".sidebar-overlay");
      if (!ov) {
        ov = document.createElement("div");
        ov.className = "sidebar-overlay";
        document.body.appendChild(ov);
      }
      return ov;
    };

    const onToggle = (e) => {
      e?.preventDefault?.();
      body.classList.toggle("mini-sidebar");         // same class your CSS expects
    };

    const onMobile = (e) => {
      e?.preventDefault?.();
      body.classList.toggle("slide-nav");            // same class your CSS expects

      // click outside to close (like the template)
      const ov = ensureOverlay();
      const close = () => {
        body.classList.remove("slide-nav");
        ov.removeEventListener("click", close);
        ov.parentNode && ov.parentNode.removeChild(ov);
      };
      ov.addEventListener("click", close);
    };

    toggleBtn?.addEventListener("click", onToggle);
    mobileBtn?.addEventListener("click", onMobile);

    return () => {
      toggleBtn?.removeEventListener("click", onToggle);
      mobileBtn?.removeEventListener("click", onMobile);
      const ov = document.querySelector(".sidebar-overlay");
      if (ov) ov.parentNode && ov.parentNode.removeChild(ov);
    };
  }, []);
}
